import toast from "react-hot-toast";
import WarningIcon from "@mui/icons-material/Warning";
import { orange } from "@mui/material/colors";

export const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

export const getComparator = (order, orderBy) => {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export const isoStringToDate = (isoString) => {
  let date = new Date(isoString);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();

  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }

  return dt + "-" + month + "-" + year;
};


export const isoStrToDate = (isoString) => {
  let date = new Date(isoString);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();
  let h = date.getHours();
  let m = date.getMinutes();
  let s = date.getSeconds();

  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }
  if (h < 10) {
    h = "0" + h;
  }
  if (m < 10) {
    m = "0" + m;
  }
  if (s < 10) {
    s = "0" + s;
  }

  return year + "/" + month + "/" + dt + " " + h + ":" + m + ":" + s;
};


export const dateLogFormatter = (dateString) => {
  let date = new Date(dateString);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();
  let h = date.getHours();
  let m = date.getMinutes();
  let s = date.getSeconds();

  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }
  if (h < 10) {
    h = "0" + h;
  }
  if (m < 10) {
    m = "0" + m;
  }
  if (s < 10) {
    s = "0" + s;
  }

  let dPart = dt + "/" + month + "/" + year;
  let hPart = h + ":" + m + ":" + s;
  let res = [dPart, hPart] 
  return res;
}

export const strCurrentDay = () => {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();

  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }

  return year + "-" + month + "-" + dt;
};

/**
 * Return string representation of dateString in parameter
 * minus one day
 * @param {*} dateString 
 * @returns 
 */
export const strDateMinusOne = (dateString) => {
  let date = new Date(dateString);
  date.setDate(date.getDate() - 1);
  
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();

  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }

  return year + "-" + month + "-" + dt;
};

/**
 * Return string representation of dateString in parameter
 * plus one day
 * @param {*} day 
 * @returns 
 */
export const strDatePlusOne = (day) => {
  let date = new Date(day);
  date.setDate(date.getDate() + 1);
   
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();

  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }

  return year + "-" + month + "-" + dt;
};

/**
 * Return string representation of dateString in parameter
 * with follwing format: YYYY-MM-DD
 * @param {*} day 
 * @returns 
 */
export const strDate = (day) => {
  let date = new Date(day);
  date.setDate(date.getDate());
   
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();

  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }

  return year + "-" + month + "-" + dt;
};

/**
 * Return string representation of dateString in parameter
 * with follwing french format: DD-MM-YYYY
 * @param {*} day 
 * @returns 
 */
 export const strDateFrFormat = (day) => {
  let date = new Date(day);
  date.setDate(date.getDate());
   
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();

  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }

  return dt + "-" + month + "-" + year;
};


export const importAllImages = (required) => {
  let images = {};
  required.keys().forEach((item, index) => {
    images[item.replace("./", "")] = required(item);
  });
  return images;
};


export const findImgGenerique = (product, images) => {
  const { marketing } = product;
  if (product.catalogueniv1 === "IMPLANT" && !product.marketing) {
    return images["IMPLANTS.png"]?.default;
  }
  if (marketing) {
    const catalogue = Object.values(marketing.catalogue1)
      .join("_")
      .replaceAll(" / ", "-")
      .replaceAll("/", "-")
      .toUpperCase();
    const catalogueLenght = Object.keys(marketing.catalogue1).length;
    if (images[catalogue + ".jpg"]?.default) {
      return images[catalogue + ".jpg"]?.default;
    } else if (images[catalogue + ".png"]?.default) {
      return images[catalogue + ".png"]?.default;
    }
    for (let index = 1; index <= catalogueLenght; index++) {
      let splitCatalogue = catalogue.split("_", catalogueLenght - index);
      if (images[splitCatalogue.join("_") + ".jpg"]?.default) {
        return images[splitCatalogue.join("_") + ".jpg"]?.default;
      } else if (images[splitCatalogue.join("_") + ".png"]?.default) {
        return images[splitCatalogue.join("_") + ".png"]?.default;
      }
    }
  }
};

export const formatPrice = (number) => {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
  }).format(number / 100);
};

export const getUniqueValues = (data, type) => {
  let unique = data.map((item) => item[type]);
  return ["TOUTES", ...new Set(unique)];
};

export const escapeRegExp = (value) => {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
};

export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const convertDate = (dateString) => {
  let p = dateString.split(/\D/g);
  return [p[2], p[1], p[0]].join("-");
};

export const capitalizeTheFirstLetterOfEachWord = (words) => {
  let separateWord = words.toLowerCase().split(" ");
  for (var i = 0; i < separateWord.length; i++) {
    separateWord[i] =
      separateWord[i].charAt(0).toUpperCase() + separateWord[i].substring(1);
  }
  return separateWord.join(" ");
};

export const convertBase64ToPdfDl = (base64, filename) => {
  let byteCharacters = atob(base64);
  let byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  let byteArray = new Uint8Array(byteNumbers);
  var file = new Blob([byteArray], { type: "application/octet-stream;base64" });
  const link = document.createElement("a");
  var fileURL = URL.createObjectURL(file);
  link.href = fileURL;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(link.href), 7000);
};

export const convertBase64ToPdfSee = (base64) => {
  let byteCharacters = atob(base64);
  let byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  let byteArray = new Uint8Array(byteNumbers);
  var file = new Blob([byteArray], { type: "application/pdf;base64" });
  var fileURL = URL.createObjectURL(file);
  window.open(fileURL);
};

export const todayDate = () => {
  const today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();
  return `${yyyy}${mm}${dd}`;
};

export const stockAlertIncrease = (itemAdded, itemExist, alertArray) => {
  if (itemExist) {
    if (itemAdded.stockdisponible < itemExist.cartQuantity + 1) {
      if (!alertArray.find((item) => item.reference === itemAdded.reference)) {
        toast(
          (t) => (
            <div>
              <p>
                Nos stocks pour l'article {itemAdded.reference} sont
                insuffisants pour satisfaire votre commande.{" "}
              </p>
              <p>
                Vous pouvez néanmoins conserver l'article dans votre panier, un
                reste à livrer sera généré automatiquement et les articles vous
                seront envoyés dès leur réassort.
              </p>
              <div>
                <button
                  style={{
                    padding: "15px",
                    background: "transparent",
                    fontSize: "inherit",
                    fontFamily: "inherit",
                    cursor: "pointer",
                  }}
                  onClick={() => toast.dismiss(t.id)}
                >
                  J'ai compris
                </button>
              </div>
            </div>
          ),
          {
            duration: Infinity,
            icon: <WarningIcon sx={{ color: orange[500] }} fontSize="large" />,
            style: {
              maxWidth: "450px",
            },
          }
        );
        alertArray.push({
          reference: itemAdded.reference,
        });
      }
    }
  }
};

export const stockAlertAdd = (itemAdded, alertArray) => {
  if (itemAdded.stockdisponible < 1) {
    toast(
      (t) => (
        <div>
          <p>
            Nos stocks pour l'article {itemAdded.reference} sont insuffisants
            pour satisfaire votre commande.{" "}
          </p>
          <p>
            Vous pouvez néanmoins conserver l'article dans votre panier, un
            reste à livrer sera généré automatiquement et les articles vous
            seront envoyés dès leur réassort.
          </p>
          <div>
            <button
              style={{
                padding: "15px",
                background: "transparent",
                fontSize: "inherit",
                fontFamily: "inherit",
                cursor: "pointer",
              }}
              onClick={() => toast.dismiss(t.id)}
            >
              J'ai compris
            </button>
          </div>
        </div>
      ),
      {
        duration: Infinity,
        icon: <WarningIcon sx={{ color: orange[500] }} fontSize="large" />,
        style: {
          maxWidth: "450px",
        },
      }
    );
    alertArray.push({
      reference: itemAdded.reference,
    });
  }
};

export const stockAlertUpdate = (itemAdded, itemAddedQuantity, alertArray) => {
  if (itemAdded.stockdisponible < itemAddedQuantity) {
    if (!alertArray.find((item) => item.reference === itemAdded.reference)) {
      toast(
        (t) => (
          <div>
            <p>
              Nos stocks pour l'article {itemAdded.reference} sont insuffisants
              pour satisfaire votre commande.{" "}
            </p>
            <p>
              Vous pouvez néanmoins conserver l'article dans votre panier, un
              reste à livrer sera généré automatiquement et les articles vous
              seront envoyés dès leur réassort.
            </p>
            <div>
              <button
                style={{
                  padding: "15px",
                  background: "transparent",
                  fontSize: "inherit",
                  fontFamily: "inherit",
                  cursor: "pointer",
                }}
                onClick={() => toast.dismiss(t.id)}
              >
                J'ai compris
              </button>
            </div>
          </div>
        ),
        {
          duration: Infinity,
          icon: <WarningIcon sx={{ color: orange[500] }} fontSize="large" />,
          style: {
            maxWidth: "450px",
          },
        }
      );
      alertArray.push({
        reference: itemAdded.reference,
      });
    }
  }
};

/**
 * TODO: Normally, api service doesn't send anymore unite property. Has to
 * be  always unitedevente
 * @param {*} actionType 
 * @param {*} head 
 * @param {*} lines 
 * @returns 
 */
export const createX3Devis = (actionType, head, lines) => {
  const linesData = lines.map((item) => (
    item.unite
      ? `L;${item.reference};${item.unite};${item.cartQuantity};;|`
      : `L;${item.reference};${item.unitedevente};${item.cartQuantity};;|`));

return encodeURIComponent(
  JSON.stringify({
    action: actionType,
    donnees: `E;CRAP;${head.type};;${head.clientCode};${todayDate()};WSEC ${head.initials} ${head.originComment};CRAP;${head.devise};;;;;|${linesData.join("")}END`,
  })
);
};

export const createX3Credits = (actionType, head, lines) => {

  let str = "";

  for (let i =0; i < lines.length; i++) {
    // préparation des morceaux de la string linesData. Permet d'eviter des
    // erreurs "Cannot read properties of null (reading 'replaceAll')"
    let des = lines[i].designation;
    des = des.replaceAll(";", " ")
    let com = lines[i].comment;
    
    com = ((com !== null && com !== undefined) ? com : "")
    com = com.trim();
    com = escapeStringField(com);
    str +=`L;${lines[i].reference};${des};${des};${lines[i].unitedevente};${lines[i].cartQuantity};${com};|`
  }
  const linesData = str;

  return encodeURIComponent(
    JSON.stringify({
      action: actionType,
      donnees: `E;CRAP;${head.type};;${head.clientCode};${todayDate()};WSEC ${head.initials} ${head.originComment};${head.shippingAddress};CRAP;${head.devise};;;;;|${linesData}END`,
    })
  );
};

export const createX3Commande = (actionType, head, lines) => {

  let str = "";

  for (let i =0; i < lines.length; i++) {
    // préparation des morceaux de la string linesData. Permet d'eviter des
    // erreurs "Cannot read properties of null (reading 'replaceAll')"
    let des = lines[i].designation;
    des = des.replaceAll(";", " ")
    let com = lines[i].comment;
    // règle de remplacement pour le champs commentaire
    com = ((com !== null && com !== undefined) ? com : "")
    com = escapeStringField(com);

    str +=`L;${lines[i].reference};${des};${des};${lines[i].unitedevente};${lines[i].cartQuantity};${lines[i].puttc};${lines[i].remise1montant};${lines[i].remise2montant};;${com};|`
  }

  const linesData = str;

  return encodeURIComponent(
    JSON.stringify({
      action: actionType,
      donnees: `E;CRAP;SON;;${head.clientCode};${todayDate()};WSEC ${head.initials} ${head.originComment};${head.shippingAddress};CRAP;${head.devise};;;;;|${linesData}END`,
    })
  );
};

export const createX3Address = (head, lines) => {
  return encodeURIComponent(
    JSON.stringify({
      action: "ZBPDLVADDR",
      donnees: `B;${head.clientCode};${head.addressLivraisonDefaut}|A;${head.addressNumber};${lines.designation};${lines.address};${lines.address2};${lines.address3};${lines.zipCode};${lines.city};${head.country};${head.country};${lines.phone};${lines.fax};1|D;CRAP;${head.clientCode};${lines.designation};TNT;${head.addressNumber}|END`,
    })
  );
};

export const sortOrderAndCredit = (cart) => {
  const order = cart.filter((item) => item.typedocument === "SON");
  const dcicp = cart.filter((item) => item.typedocument === "DCICP");
  const dcpil = cart.filter((item) => item.typedocument === "DCPIL");

  return { order: order, dcicp: dcicp, dcpil: dcpil };
};

// Rôle : Gestion robuste des noms d'utilisateur
// Validation : Vérifie que le nom existe et est une chaîne
// Gestion des cas limites : Nom vide, un seul mot, etc.
// Fallback : Affiche 'U' si aucun nom valide
export const stringAvatar = (name, color) => {
  if (!name || typeof name !== 'string') {
    return {
      sx: {
        bgcolor: color,
      },
      children: 'U',
    };
  }
  
  const nameParts = name.trim().split(" ");
  const firstName = nameParts[0] || '';
  const lastName = nameParts[1] || '';
  
  const firstInitial = firstName[0] || '';
  const lastInitial = lastName[0] || '';
  
  return {
    sx: {
      bgcolor: color,
    },
    children: `${firstInitial.toUpperCase()}${lastInitial.toUpperCase()}` || 'U',
  };
};

export const escapeStringField = (value) => {

  value = value.replaceAll("\n", ' ');
  value = value.replaceAll("\t", ' ');
  value = value.replaceAll("\r", ' ');
  value = value.replaceAll("\\x", ' '); //hexa number

  var chars = {
    ';'  : ',',
    '"'  : "'",
    "'"  : "'",
    '&'  : ' ',
    '<'  : ' ',
    '>'  : ' ',
    '~'  : ' ',
    '#'  : ' ',
    '{'  : ' ',
    '}'  : ' ',
    '('  : ' ',
    ')'  : ' ',
    '['  : ' ',
    ']'  : ' ',
    '|'  : ' ',
    '`'  : ' '
  };
  value = value.trim();
  return value.replace(/[;"'&<>~#{}()[\]|`]/g, c => chars[c]);

};

/**
 * 
 * @param {*} logs 
 * @param {*} day 
 * @returns 
 */
export const countLogsPerHour = (logs, day) => {
  let strDay = day;
  
  let nb0 = 0;
  let nb1 = 0;
  let nb2 = 0;
  let nb3 = 0;
  let nb4 = 0;
  let nb5 = 0;
  let nb6 = 0;
  let nb7 = 0;
  let nb8 = 0;
  let nb9 = 0;
  let nb10 = 0;
  let nb11 = 0;
  let nb12 = 0;
  let nb13 = 0;
  let nb14 = 0;
  let nb15 = 0;
  let nb16 = 0;
  let nb17 = 0;
  let nb18 = 0;
  let nb19 = 0;
  let nb20 = 0;
  let nb21 = 0;
  let nb22 = 0;
  let nb23 = 0;
      
  logs.length > 0 && logs.forEach(log => {
    if (log.created_at >= (strDay + " 00:00:00") && log.created_at < (strDay + " 01:00:00")) {
      nb0 += 1;
    } else if (log.created_at >= (strDay + " 01:00:00") && log.created_at < (strDay + " 02:00:00")) {
      nb1 += 1;
    } else if (log.created_at >= (strDay + " 02:00:00") && log.created_at < (strDay + " 03:00:00")) {
      nb2 += 1;
    } else if (log.created_at >= (strDay + " 03:00:00") && log.created_at < (strDay + " 04:00:00")) {
      nb3 += 1;
    } else if (log.created_at >= (strDay + " 04:00:00") && log.created_at < (strDay + " 05:00:00")) {
      nb4 += 1;
    } else if (log.created_at >= (strDay + " 05:00:00") && log.created_at < (strDay + " 06:00:00")) {
      nb5 += 1;
    } else if (log.created_at >= (strDay + " 06:00:00") && log.created_at < (strDay + " 07:00:00")) {
      nb6 += 1;
    } else if (log.created_at >= (strDay + " 07:00:00") && log.created_at < (strDay + " 08:00:00")) {
      nb7 += 1;
    } else if (log.created_at >= (strDay + " 08:00:00") && log.created_at < (strDay + " 09:00:00")) {
      nb8 += 1;
    } else if (log.created_at >= (strDay + " 09:00:00") && log.created_at < (strDay + " 10:00:00")) {
      nb9 += 1;
    } else if (log.created_at >= (strDay + " 10:00:00") && log.created_at < (strDay + " 11:00:00")) {
      nb10 += 1;
    } else if (log.created_at >= (strDay + " 11:00:00") && log.created_at < (strDay + " 12:00:00")) {
      nb11 += 1;
    } else if (log.created_at >= (strDay + " 12:00:00") && log.created_at < (strDay + " 13:00:00")) {
      nb12 += 1;
    } else if (log.created_at >= (strDay + " 13:00:00") && log.created_at < (strDay + " 14:00:00")) {
      nb13 += 1;
    } else if (log.created_at >= (strDay + " 14:00:00") && log.created_at < (strDay + " 15:00:00")) {
      nb14 += 1;
    } else if (log.created_at >= (strDay + " 15:00:00") && log.created_at < (strDay + " 16:00:00")) {
      nb15 += 1;
    } else if (log.created_at >= (strDay + " 16:00:00") && log.created_at < (strDay + " 17:00:00")) {
      nb16 += 1;
    } else if (log.created_at >= (strDay + " 17:00:00") && log.created_at < (strDay + " 18:00:00")) {
      nb17 += 1;
    } else if (log.created_at >= (strDay + " 18:00:00") && log.created_at < (strDay + " 19:00:00")) {
      nb18 += 1;
    } else if (log.created_at >= (strDay + " 19:00:00") && log.created_at < (strDay + " 20:00:00")) {
      nb19 += 1;
    } else if (log.created_at >= (strDay + " 20:00:00") && log.created_at < (strDay + " 21:00:00")) {
      nb20 += 1;
    } else if (log.created_at >= (strDay + " 21:00:00") && log.created_at < (strDay + " 22:00:00")) {
      nb21 += 1;
    } else if (log.created_at >= (strDay + " 22:00:00") && log.created_at < (strDay + " 23:00:00")) {
      nb22 += 1;
    } else if (log.created_at >= (strDay + " 23:00:00") && log.created_at <= (strDay + " 23:59:59")) {
      nb22 += 1;
    }
  })

  let nbLogsPerHour = [nb0, nb1, nb2, nb3, nb4, nb5, nb6, nb7, nb8, nb9, nb10, nb11, nb12,
                       nb13, nb14, nb15, nb16, nb17, nb18, nb19, nb20, nb21, nb22, nb23];
  
  return nbLogsPerHour;
}
